/* CRO2610-Lights page: the two-tap light finder (sections/cro2610-lights.liquid). */
(function () {
  'use strict';
  var ORDER = { 'one|big': ['helio', 'xl'], 'one|small': ['helio', 'stems'], 'many|big': ['helio', 'xl'], 'many|small': ['helio', 'shelves'] };
  function init(box) {
    var n = null, size = null, sun = null;
    var result = box.querySelector('[data-twl-result]'), hours = box.querySelector('[data-twl-hours]');
    function press(attr, val) {
      Array.prototype.forEach.call(box.querySelectorAll('[' + attr + ']'), function (b) {
        b.setAttribute('aria-pressed', b.getAttribute(attr) === val ? 'true' : 'false');
      });
    }
    function show() {
      if (!n || !size) return;
      var picks = result.querySelectorAll('[data-twl-key]'), shown = 0, list = ORDER[n + '|' + size] || [];
      Array.prototype.forEach.call(picks, function (a) { a.hidden = true; });
      // a market that does not sell a light has no card for it: the next one in the order moves up
      list.forEach(function (key) {
        if (shown >= 2) return;
        var a = result.querySelector('[data-twl-key="' + key + '"]');
        if (!a) return;
        if (shown === 1 && n === 'many' && key === 'xl' && result.querySelector('[data-twl-key="helio"]')) return;
        a.hidden = false;
        a.parentNode.appendChild(a);
        a.querySelector('[data-twl-label]').textContent = shown === 0 ? 'Top pick' : 'Also good';
        a.querySelector('[data-twl-one]').hidden = n !== 'one';
        a.querySelector('[data-twl-many]').hidden = n !== 'many';
        shown++;
      });
      result.appendChild(hours);
      hours.textContent = sun ? (hours.getAttribute('data-' + sun) || '') : 'Tell us about the daylight for a timer tip.';
      result.hidden = shown === 0;
    }
    box.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b || !box.contains(b)) return;
      if (b.hasAttribute('data-twl-n')) { n = b.getAttribute('data-twl-n'); press('data-twl-n', n); }
      else if (b.hasAttribute('data-twl-size')) { size = b.getAttribute('data-twl-size'); press('data-twl-size', size); }
      else if (b.hasAttribute('data-twl-sun')) { sun = b.getAttribute('data-twl-sun'); press('data-twl-sun', sun); }
      else return;
      show();
    });
  }
  function extras() {
    var bar = document.querySelector('[data-twl-sticky]'), hero = document.querySelector('[data-twl-hero]');
    if (bar && hero && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        var show = !es[0].isIntersecting && es[0].boundingClientRect.top < 0;
        bar.setAttribute('data-show', show ? 'true' : 'false');
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        var a = bar.querySelector('a'); if (a) a.tabIndex = show ? 0 : -1;
      }).observe(hero);
    }
    var clips = document.querySelectorAll('.twl-clip__v');
    if (clips.length && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { var v = e.target; if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause(); });
      }, { threshold: 0.5 });
      Array.prototype.forEach.call(clips, function (v) { v.muted = true; io.observe(v); });
    }
  }
  function guide(box) {
    box.addEventListener('click', function (e) {
      var b = e.target.closest('[data-twl-g]');
      if (!b || !box.contains(b)) return;
      var id = b.getAttribute('data-twl-g');
      Array.prototype.forEach.call(box.querySelectorAll('[data-twl-g]'), function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      Array.prototype.forEach.call(box.querySelectorAll('[data-twl-gcard]'), function (c) { c.hidden = c.getAttribute('data-twl-gcard') !== id; });
    });
  }
  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-twl-finder]:not([data-twl-ready])'), function (b) { b.setAttribute('data-twl-ready', ''); init(b); });
    Array.prototype.forEach.call(document.querySelectorAll('[data-twl-guide]:not([data-twl-ready])'), function (b) { b.setAttribute('data-twl-ready', ''); guide(b); });
    extras();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
